import { useEffect, useRef } from 'react';

/**
 * Custom hook for detecting clicks outside a specified element
 * Useful for dropdown menus, modals, and other overlay components
 */
export function useOutsideClick<T extends HTMLElement = HTMLElement>(
  callback: () => void,
  listenWhen: boolean = true
) {
  const ref = useRef<T>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    if (listenWhen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () =>
        document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [callback, listenWhen]);

  return ref;
}
